"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Application = _interopRequireDefault(require("ComposeUI/containers/Application"));

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var routes = [_react.default.createElement(_reactRouter.Route, {
  key: "app",
  path: "/:contentType/:contentId",
  component: _Application.default
})];
var _default = routes;
exports.default = _default;
module.exports = exports.default;